































































import { Component, Vue } from 'vue-property-decorator';
import { HttpError } from '@easygenerator/fragment-sdk';
import { HttpStatus } from '../../types/http';
import Button from '@/components/Button.vue';
import Notification from '@/components/notification/Notification.vue';
import PasswordField from '@/components/auth-form/PasswordField.vue';

@Component({
  components: { Button, PasswordField, Notification }
})
export default class DeleteAccount extends Vue {
  isDeleteAccountPopupVisible = false;

  isAccountDeletedPopupVisible = false;

  password = '';

  passwordIncorrect = false;

  errorText = '';

  showPasswordError(errorText: string) {
    this.errorText = errorText;
    this.passwordIncorrect = true;
  }

  hidePasswordError() {
    this.errorText = '';
    this.passwordIncorrect = false;
  }

  openDeleteAccountDialog() {
    this.isDeleteAccountPopupVisible = true;
  }

  closeDeleteAccountDialog() {
    this.isDeleteAccountPopupVisible = false;
  }

  openAccountDeletedDialog() {
    this.isAccountDeletedPopupVisible = true;
  }

  async logout() {
    try {
      await this.$store.dispatch('app/logout');
    } finally {
      this.$router.push({ path: 'login' });
    }
  }

  async deleteAccount() {
    try {
      if (!this.password) {
        this.showPasswordError(this.$t('missingPasswordValidationError'));
        return;
      }

      this.hidePasswordError();

      await this.$store.dispatch('user/deleteAccount', { password: this.password });

      this.closeDeleteAccountDialog();
      this.openAccountDeletedDialog();
    } catch (e) {
      const error = e as HttpError;

      if (error.status === HttpStatus.Forbidden && error.message === 'Password invalid') {
        this.showPasswordError(this.$t('invalidPasswordErrorMessage'));
      } else {
        this.showPasswordError((e as Error).message);
      }
    }
  }
}
